import React from "react";

import { mobileScreenType } from "@stadium/constants";

import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";
import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

const TextWithCTAandOverlappingImage = ({ doc, currentDevice }) => {
  const {
    text,
    image: { url: webImageUrl = "", alt: imageAlt = "" },
    mobile_image: { url: mobileImageUrl = "" } = {},
    description,
    bg_color,
    text_alignment_dropdown,
  } = doc?.primary || {};
  const { items = [] } = doc || {};
  const style = { backgroundColor: bg_color };
  const alignClass = text_alignment_dropdown === "align-right" ? "flex-row-reverse" : "";

  const imageUrl = currentDevice === mobileScreenType ? mobileImageUrl : webImageUrl;

  return (
    <div
      className="mt-md-5 mt-2xl-5 pt-5 pt-md-0 text-with-overlapping-image prismic-slice"
      style={style}
    >
      <div className="container container-width text-with-overlapping-image-container">
        <div className={`text-with-overlapping-image-content-section ${alignClass}`}>
          <div className="text-with-overlapping-image-content-block">
            <div className="pl-md-3 pl-xl-5 pl-2xl-5 text-with-overlapping-image-content-holder">
              {checkContentPresence(text) && (
                <div className="sns-h2 text-with-overlapping-image-title">{textResolver(text)}</div>
              )}
              {checkContentPresence(description) && (
                <div className="mt-4 mt-2xl-4 sns-h4 text-with-overlapping-image-description">
                  {textResolver(description)}
                </div>
              )}
              <div className="mt-3 mt-lg-5 mt-2xl-5 d-md-flex flex-row flex-wrap text-with-overlapping-image-btns-row">
                {items?.map(({ link: { url, target } = {}, link_text, button_design }) => {
                  const subLinkClassName =
                    button_design === "transparent_background"
                      ? "button-program-outline-green btn"
                      : "button-program-green";
                  const linkClassName = ["solid_background", "transparent_background"].includes(
                    button_design
                  )
                    ? `button ${subLinkClassName} 
                      px-3 px-lg-5 py-3 btn-block text-white font-weight-bold no-underline text-uppercase text-break ls-3 button-marketing`
                    : "sns-h4 program-link text-uppercase font-weight-bold ls-3";
                  return (
                    <div className="text-with-overlapping-image-btns-holder">
                      {url && (
                        <PrismicLinkTag
                          urlText={link_text}
                          url={url}
                          target={target}
                          className={linkClassName}
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="text-with-overlapping-image-asset-block text-center">
            {imageUrl && (
              <PrismicImgix
                alt={imageAlt}
                src={imageUrl}
                className="d-inline-block text-with-overlapping-image-asset"
                desktop="840px"
                mobile="375px"
                tablet="400px"
                largeDisplay="2400px"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextWithCTAandOverlappingImage;
